import React from 'react';
import { getTransactionId } from '../lib/stripe';

export const useTransactionId =  (quizId: number | undefined) => {
  const [transactionData, setTransactionData] = React.useState<{
    status: string;
    transaction_id: string | null;
    subscription_id?: string;
    customer_id?: string;
    type?: 'subscription' | 'purchase';
    error?: string;
  } | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!quizId) {
      setTransactionData(null);
      return;
    }

    const fetchTransactionId = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await getTransactionId(quizId);
        setTransactionData(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to get transaction ID');
        setTransactionData({ status: 'error', transaction_id: null, error: err instanceof Error ? err.message : 'Failed to get transaction ID' });
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionId();
  }, [quizId]);

  return { transactionData, loading, error };
}